// extracted by mini-css-extract-plugin
export var autoExpand = "_1r-8";
export var container = "_1r-7";
export var containerWidth = "_1r-5";
export var disabled = "_1r-2";
export var error = "_1r-3";
export var fullWidth = "_1r-6";
export var inputWrapper = "_1r-0";
export var small = "_1r-1";
export var textarea = "_1r-4";